import * as yup from 'yup';
import { ExperienceCriteria } from '@/Models/ExperienceCriteria';
import YupValidationErrors from '@/Utils/YupValidationErrors';

interface RHFCriteriaValue {
    criteriaId: string;
    value: string;
}

export interface ExperienceCriteriaForm {
    criteria: RHFCriteriaValue[];
}

export const minExperienceCriteria = 1;
export const maxExperienceCriteria = 5;

export const experienceCriteriaFormSchema: yup.SchemaOf<ExperienceCriteriaForm> = yup.object({
    criteria: yup
        .array()
        .max(maxExperienceCriteria)
        .min(minExperienceCriteria, YupValidationErrors.PleaseAddAtLeastOneCriteriaRequiredError)
        .of(
            // this can be simplified with yup.ObjectSchema or even inferred, but does not work maybe because yup is outdated
            yup.object<Record<keyof RHFCriteriaValue, yup.StringSchema>>({
                criteriaId: yup.string().defined(),
                value: yup
                    .string()
                    .required(YupValidationErrors.Required)
                    .max(1024, YupValidationErrors.MaxSymbolsValidationError),
            }),
        )
        .required(),
});

export const experienceCriteriaFieldNames: { [key in keyof ExperienceCriteriaForm]: key } = {
    criteria: 'criteria',
};

export const mapRhfCriteriaToExperienceCriteria = (rhfCriteria: RHFCriteriaValue): ExperienceCriteria => ({
    id: rhfCriteria.criteriaId,
    criterion: rhfCriteria.value,
});
export const mapExperienceCriteriaToRhfCriteria = (criteria: ExperienceCriteria): RHFCriteriaValue => ({
    criteriaId: criteria.id,
    value: criteria.criterion,
});
